import { render, staticRenderFns } from "./addCount.vue?vue&type=template&id=70ed36a6&scoped=true"
import script from "./addCount.vue?vue&type=script&lang=js"
export * from "./addCount.vue?vue&type=script&lang=js"
import style0 from "./addCount.vue?vue&type=style&index=0&id=70ed36a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed36a6",
  null
  
)

export default component.exports